import { JpatsPolicyPermissionsService } from './services/jpats-policy-permissions.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../../../shared/core/core.module';
import { AppRoutingModule } from '../../app-routing.module';
import {ApiModule} from "../../api/api.module";
import {AuthApiService} from "./services/auth.service";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import { JpatsAuthRequestInterceptor } from "./interceptors/auth-request.interceptor";
import { JpatsPolicyPermissionsGuard } from './services/jpats-policy-permissions.guard';


@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    AppRoutingModule,
    ApiModule
  ],
  providers: [
    AuthApiService,
    JpatsPolicyPermissionsService,
    JpatsPolicyPermissionsGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JpatsAuthRequestInterceptor  ,
      multi: true
    }],
  exports: [
    AppRoutingModule
  ]
})
export class CoreJpatsModule { }
